<template>
  <div class="w-100 btn-group" role="group">
    <div class="w-100" v-for="item in items">
      <b-button
        type="button"
        class="w-100 btn btn-secondary"
        @click="onClick(item.URL)"
        variant="dark"
        squared
      >
        <component :is="item.icon + '-icon'"></component>
        {{ item.text }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: {
    items: { type: Array, default: [] },
  },
  data: () => ({}),
  methods: {
    onClick(url) {
      if (url.startsWith("http")) {
        window.location.href = url;
      } else {
        this.$router.push(url);
      }
    },
  },
  computed: {},
  watch: {},
  created() {},
};
</script>

<style>
.btn-group {
  margin-bottom: 10px;
}
</style>
